import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { selectWebsiteTheme } from '../../store/slices/website';
import CLFontIcon from '../CLFontIcon';

import { Container, Select, ToggleIcon } from './styled';

const CLSelect = ({
  options, keyExtractor, value, onChange,
}) => {
  const { colors } = useSelector(selectWebsiteTheme);
  const { t } = useTranslation();

  return (
    <Container>
      <Select
        oColor={colors[6].color}
        bColor={colors[3].color}
        bgColor={colors[0].color}
        value={value}
        onChange={(event) => onChange(event.nativeEvent.target.value)}
      >
        <option value="">{t('select', 'Select')}</option>
        {options && options.map((option) => (
          <option
            key={keyExtractor(option)}
            value={keyExtractor(option)}
          >
            {option.name}
          </option>
        ))}
      </Select>

      <ToggleIcon
        color={colors[4].color}
      >
        <CLFontIcon icon="caret" />
      </ToggleIcon>
    </Container>
  );
};

CLSelect.propTypes = {
  options: PropTypes.array.isRequired,
  keyExtractor: PropTypes.func.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

CLSelect.defaultProps = {
  value: '',
};

export default CLSelect;
